import { call, delay, select, take, put } from 'redux-saga/effects';
import { isMasquerade as getIsMasquerade } from 'modules/auth';
import { initialized as gtmInitialized } from 'modules/gtm/selectors';
import gtmActions from 'modules/gtm/actions';

import AttributionData from './AttributionData';
import attributionActions from './actions';

const TIMEOUT = 5; // seconds

export function* waitForGaReady() {
	// Need GTM initialized for GA attribution to setup properly
	if (!(yield select(gtmInitialized))) {
		take(gtmActions.INITIALIZED);
	}
	let timeout = 0;
	while (window.dataLayer === undefined && timeout <= TIMEOUT * 1000) {
		yield delay(500);
		timeout += 500;
	}
}

export function* getAttributionData() {
	const isMasquerade = yield select(getIsMasquerade);
	if (isMasquerade) return false;

	const attributionDataCreator = new AttributionData();

	const attributionData = attributionDataCreator.all;
	if (!attributionData.referral && !attributionData.attribution) return false;

	return attributionData;
}

export function* gaSendAttributionData(basketDetails) {
	yield call(waitForGaReady);

	const attributionData = yield call(getAttributionData);
	if (attributionData) {
		yield put(
			attributionActions.sendPurchaseGaData({ attributionData, basketDetails }),
		);
	}
}
